<template>
  <div id="container">
    <div id="mu_container">
      <el-table
        :data="users.filter(oneUser => !search || oneUser.user_phone.toLowerCase().includes(search.toLowerCase()) || oneUser.user_name.toLowerCase().includes(search.toLowerCase()))"
        style="width: 100%">
        <el-table-column
          type="index"
          :index="indexMethod">
        </el-table-column>
        <el-table-column
          label="Phone"
          prop="user_phone"
          width="150"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          label="User"
          prop="user_name"
          width="200"
          show-overflow-tooltip>

        </el-table-column>
        <el-table-column
          label="Projects"
          width="600"
          prop="project_id">
          <template slot-scope="scope">
            <el-tag type="info" :key="'project_' + i" v-for="(name, i) in analProjects(scope.row.project_id)">
              {{ name }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align="right">
          <template slot="header" slot-scope="scope">
            <el-input
              id="input_sixty"
              v-model="search"
              size="small"
              clearable
              placeholder="search user"/>
            <el-button type="primary" size="mini" icon="el-icon-plus" circle @click="handleAdd()"></el-button>
          </template>
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleEdit(scope.$index, scope.row)">Edit
            </el-button>
            <el-popconfirm

              title="Reset password to 123456"
              confirm-button-text="Confirm"
              cancel-button-text="Cancel"
              @confirm="handleResetPassword(scope.$index, scope.row)"
            >
              <el-button slot="reference" size="mini" type="warning">Reset password</el-button>
            </el-popconfirm>
            <el-popconfirm
              title="Do you want to delete this user?"
              confirm-button-text="Confirm"
              cancel-button-text="Cancel"
              @confirm="handleDelete(scope.$index, scope.row)"
            >
              <el-button slot="reference" size="mini" type="danger">Delete</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog :title="user.user_name" :visible.sync="editProjectsFormVisible"
               @opened="handleEditOpen"
               @closed="handleAddClose('', '')">
      <!--      <el-form>-->
      <!--        <el-form-item label="User phone:" :label-width="formLabelWidth">-->
      <!--          <el-link type="primary" disabled>{{ user.user_phone }}</el-link>-->
      <!--        </el-form-item>-->
      <!--        <el-form-item label="User name:" :label-width="formLabelWidth">-->
      <!--          <el-link type="primary" disabled>{{ user.user_name }}</el-link>-->
      <!--        </el-form-item>-->
      <!--      </el-form>-->

      <el-form :model="form" :rules="rules" ref="addUserForm">
        <el-form-item label="User phone" :label-width="formLabelWidth" prop="phone">
          <el-input @input="editUserChange" v-model="form.phone" autocomplete="off" size="medium" clearable></el-input>
        </el-form-item>
        <el-form-item label="User name" :label-width="formLabelWidth" prop="user">
          <el-input @input="editUserChange" v-model="form.user" autocomplete="off" size="medium" clearable></el-input>
        </el-form-item>
        <!--        <el-form-item label="role" :label-width="formLabelWidth">-->
        <!--          <el-select size="medium" v-model="form.role" placeholder="select role">-->
        <!--            <el-option v-for="(item, i) in roles" :key="'role_' + i" :label="item.role_name"-->
        <!--                       :value="item.role_id"></el-option>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
      </el-form>

      <el-table
        ref="editProjectsTable"
        :data="projects"
        tooltip-effect="dark"
        style="width: 100%"
        @select-all="handleSelectAllChange"
        @select="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="project_name"
          label="Project Name"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column>
          <template slot-scope="scope">
            <el-checkbox
              :indeterminate="isIndeterminate[scope.$index]"
              v-model="checkAll[scope.$index]"
              @change="handleEditCheckAllChange($event, scope.$index)">
              Select models
            </el-checkbox>
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group
              v-model="checkedModels[scope.$index]"
              @change="handleEditCheckedModelsChange($event, scope.$index)">
              <el-checkbox v-for="(model, index) in models" :label="model" :key="Math.random()">
                {{ model.model_name }}
              </el-checkbox>
            </el-checkbox-group>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editProjectsFormVisible = false">Cancel</el-button>
        <el-button type="primary" @click="handleConfirmProjects('addUserForm')"
                   :disabled="selectProjects.length==0 || confirmLoading || justOpen"
                   :loading="confirmLoading">Confirm
        </el-button>
      </div>
    </el-dialog>

    <el-dialog title="Add a user" :visible.sync="addNewUserFormVisible"
               @opened="handleAddOpen"
               @closed="handleAddClose('', '')">
      <el-form :model="form" :rules="rules" ref="addUserForm">
        <el-form-item label="User phone" :label-width="formLabelWidth" prop="phone">
          <el-input v-model="form.phone" autocomplete="off" size="medium" clearable></el-input>
        </el-form-item>
        <el-form-item label="User name" :label-width="formLabelWidth" prop="user">
          <el-input v-model="form.user" autocomplete="off" size="medium" clearable></el-input>
        </el-form-item>
        <!--        <el-form-item label="role" :label-width="formLabelWidth">-->
        <!--          <el-select size="medium" v-model="form.role" placeholder="select role">-->
        <!--            <el-option v-for="(item, i) in roles" :key="'role_' + i" :label="item.role_name"-->
        <!--                       :value="item.role_id"></el-option>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
      </el-form>
      <el-table
        name="addUserTable"
        ref="addNewUserTable"
        :data="projects"
        key="projects"
        tooltip-effect="dark"
        style="width: 100%"
        @select-all="handleSelectAllChange"
        @select="handleSelectionChange">

        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="project_name"
          label="Project Name"
          show-overflow-tooltip>
        </el-table-column>

        <el-table-column>
          <template slot-scope="scope">
            <el-checkbox
              :indeterminate="isIndeterminate[scope.$index]"
              v-model="checkAll[scope.$index]"
              @change="handleCheckAllChange($event, scope.$index)">
              Select models
            </el-checkbox>
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group
              v-model="checkedModels[scope.$index]"
              @change="handleCheckedModelsChange($event, scope.$index)">
              <el-checkbox v-for="(model, index) in models" :label="model" :key="Math.random()">
                {{ model.model_name }}
              </el-checkbox>
            </el-checkbox-group>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addNewUserFormVisible = false">Cancel</el-button>
        <el-button type="primary" @click="handleAddUser('addUserForm')"
                   :disabled="selectProjects.length==0 || confirmLoading || justOpen"
                   :loading="confirmLoading">Confirm
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: "manageuser",
  data() {
    return {
      name: 'manage user',
      user_name: window.localStorage.getItem("token_key"),
      constractor_id: window.localStorage.getItem("cons_id"),
      constractor_name: window.localStorage.getItem("cons_name"),
      projects: [],
      users: [],
      user: '',
      user_index: -1,
      roles: [],
      search: '',
      editProjectsFormVisible: false,
      addNewUserFormVisible: false,
      confirmLoading: false,
      justOpen: true,
      selectProjects: [],
      mountedLoading: null,
      form: {
        user: '',
        phone: '',
      },
      rules: {
        user: [
          {required: true, message: 'please input your name.', trigger: 'blur'}
        ],
        phone: [
          {required: true, message: 'please input your phone number.', trigger: 'blur'}
        ]
      },
      formLabelWidth: '100px',

      models: [],
      checkAll: [],
      checkedModels: [],
      isIndeterminate: [],
      selectProjectIds: []
    }
  },
  methods: {

    handleCheckAllChange(val, index) {
      this.checkedModels[index] = val ? this.models : []
      this.isIndeterminate[index] = false
      var project = this.projects[index]
      var pro_index = this.selectProjects.indexOf(project)
      if (val && pro_index < 0) {
        this.selectProjects.push(project)
        this.selectProjectIds.push(project.project_id)
        this.$refs.addNewUserTable.toggleRowSelection(project, true);
      }
      if ((!val) && pro_index >= 0) {
        this.selectProjects.splice(pro_index, 1)
        this.selectProjectIds.splice(pro_index, 1)
        this.$refs.addNewUserTable.toggleRowSelection(project, false);
      }
    },

    editUserChange() {
      this.justOpen = false
    },

    handleEditCheckAllChange(val, index) {
      this.justOpen = false
      this.checkedModels[index] = val ? this.models : []
      this.isIndeterminate[index] = false
      var project = this.projects[index]
      var pro_index = this.selectProjects.indexOf(project)
      if (val && pro_index < 0) {
        this.selectProjects.push(project)
        this.selectProjectIds.push(project.project_id)
        this.$refs.editProjectsTable.toggleRowSelection(project, true);
      }
      if ((!val) && pro_index >= 0) {
        this.selectProjects.splice(pro_index, 1)
        this.selectProjectIds.splice(pro_index, 1)
        this.$refs.editProjectsTable.toggleRowSelection(project, false);
      }
    },

    getIndeterminate(index) {
      return this.isIndeterminate[index]
    },
    handleCheckedModelsChange(value, index) {
      let checkedCount = value.length;
      this.$set(this.checkAll, index, checkedCount == this.models.length)
      this.isIndeterminate[index] = checkedCount > 0 && checkedCount < this.models.length;
      var project = this.projects[index]
      var pro_index = this.selectProjects.indexOf(project)
      if (checkedCount > 0 && pro_index < 0) {
        this.selectProjects.push(project)
        this.selectProjectIds.push(project.project_id)
        this.$refs.addNewUserTable.toggleRowSelection(project, true)
      }
      if (checkedCount == 0 && pro_index >= 0) {
        this.selectProjects.splice(pro_index, 1)
        this.selectProjectIds.splice(pro_index, 1)
        this.$refs.addNewUserTable.toggleRowSelection(project, false)
      }
    },
    handleEditCheckedModelsChange(value, index) {
      this.justOpen = false
      let checkedCount = value.length;
      this.$set(this.checkAll, index, checkedCount == this.models.length)
      this.isIndeterminate[index] = checkedCount > 0 && checkedCount < this.models.length;
      var project = this.projects[index]
      var pro_index = this.selectProjects.indexOf(project)
      if (checkedCount > 0 && pro_index < 0) {
        this.selectProjects.push(project)
        this.selectProjectIds.push(project.project_id)
        this.$refs.editProjectsTable.toggleRowSelection(project, true)
      }
      if (checkedCount == 0 && pro_index >= 0) {
        this.selectProjects.splice(pro_index, 1)
        this.selectProjectIds.splice(pro_index, 1)
        this.$refs.editProjectsTable.toggleRowSelection(project, false)
      }
    },
    handleAdd() {
      this.addNewUserFormVisible = true
      this.$nextTick(() => {
        this.projects.forEach(project => {
          this.$refs.addNewUserTable.toggleRowSelection(project, false);
        })
      })
    },
    handleAddUser(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addUser();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    addUser() {
      var ids = ''
      this.selectProjects.forEach(project => {
        ids = ids + project.project_id + ','
      })
      ids = ids.substring(0, ids.length - 1)
      var addModels = []
      for (const i in this.projects) {
        var checked = this.checkedModels[i]
        if (checked.length > 0) {
          var model_ids = ''
          checked.forEach(model => {
            model_ids = model_ids + model.model_name + '|'
          })
          model_ids = model_ids.substring(0, model_ids.length - 1)
          addModels.push({
            project_id: this.projects[i].project_id,
            models: model_ids
          })
        }
      }
      var name = this.form.user
      var phone = this.form.phone
      let postData = {
        cms_conid: window.localStorage.getItem('cons_id'),
        user: window.localStorage.getItem("token_key"),
        token: window.localStorage.getItem('token'),
        project_id: ids,
        role: 2,
        phone: phone,
        user_name: name,
        model_list: addModels
      }
      this.confirmLoading = true
      axios.post(this.$store.getters.getBesServer + "CMSAddUser", postData).then(resp => {
        var errNo = resp.data.errno
        var errStr = resp.data.errstr
        if (errNo == "0") {
          this.alert('Add User successfully!', 2)
          var user = {
            id: resp.data.result.id,
            models: addModels,
            project_id: ids,
            role: 2,
            user_name: name,
            user_phone: phone
          }
          this.users.push(user)
          this.addNewUserFormVisible = false
          this.confirmLoading = false
        } else {
          alert('Add User Error: ' + errStr)
          this.addNewUserFormVisible = false
          this.confirmLoading = false
        }
      }).catch(error => {
        alert('Add User Error: ' + error)
        this.addNewUserFormVisible = false
        this.confirmLoading = false
      })
    },
    handleResetPassword(index, row) {
      let postData = {
        cms_conid: window.localStorage.getItem('cons_id'),
        user: window.localStorage.getItem("token_key"),
        token: window.localStorage.getItem('token'),
        id: row.id
      }
      axios.post(this.$store.getters.getBesServer + "CMSResetPassword", postData).then(resp => {
        var errNo = resp.data.errno
        var errStr = resp.data.errstr
        if (errNo == "0") {
          this.alert('Reset Password successfully!', 2)
        } else {
          alert('Reset Password Error: ' + errStr)
        }
      }).catch(error => {
        alert('Reset Password Error: ' + error)
      })
    },
    handleDelete(index, row) {
      let postData = {
        cms_conid: window.localStorage.getItem('cons_id'),
        user: window.localStorage.getItem("token_key"),
        token: window.localStorage.getItem('token'),
        id: row.id
      }
      axios.post(this.$store.getters.getBesServer + "CMSDeleteUser", postData).then(resp => {
        var errNo = resp.data.errno
        var errStr = resp.data.errstr
        if (errNo == "0") {
          this.alert('Deleted successfully!', 3)
          this.users.splice(index, 1)
        } else {
          alert('Delete User Error: ' + errStr)
        }
      }).catch(error => {
        alert('Delete User Error: ' + error)
      })
    },
    handleSelectionChange(val) {
      this.justOpen = false
      var selected = val
      var selectedIds = this.selectProjectIds
      var contain = []
      for (let project of this.projects) {
        var index = selected.indexOf(project)
        var ori_index = selectedIds.indexOf(project.project_id)
        if (index < 0 && ori_index >= 0) {
          contain.push(-1)
        } else if (index < 0 && ori_index < 0) {
          contain.push(-2)
        } else if (index >= 0 && ori_index < 0) {
          contain.push(index)
        } else if (index >= 0 && ori_index >= 0) {
          contain.push(-2)
        }
      }

      for (let i = 0; i < contain.length; i++) {
        var index = contain[i]
        if (index == -1) {
          this.$set(this.checkAll, i, false)
          this.isIndeterminate[i] = false
          this.checkedModels[i] = []
        } else if (index >= 0) {
          this.$set(this.checkAll, i, true)
          this.isIndeterminate[i] = false
          this.checkedModels[i] = this.models
        }
      }
      this.selectProjects = val
      this.selectProjectIds = []
      for (const selectProject of this.selectProjects) {
        this.selectProjectIds.push(selectProject.project_id)
      }
    },

    handleSelectAllChange(val) {
      this.justOpen = false
      var selected = val
      var selectedIds = this.selectProjectIds
      var contain = []
      for (let project of this.projects) {
        var index = selected.indexOf(project)
        var ori_index = selectedIds.indexOf(project.project_id)
        if (index < 0 && ori_index >= 0) {
          contain.push(-1)
        } else if (index < 0 && ori_index < 0) {
          contain.push(-2)
        } else if (index >= 0 && ori_index < 0) {
          contain.push(index)
        } else if (index >= 0 && ori_index >= 0) {
          contain.push(-2)
        }
      }

      for (let i = 0; i < this.projects.length; i++) {
        let checkNone = val.length == 0;
        if (checkNone) {
          this.checkAll[i] = false
          this.isIndeterminate[i] = false
          this.checkedModels[i] = []
        } else {
          this.checkAll[i] = true
          this.isIndeterminate[i] = false
          this.checkedModels[i] = this.models
        }
      }
      this.selectProjects = val
      this.selectProjectIds = []
      for (const selectProject of this.selectProjects) {
        this.selectProjectIds.push(selectProject.project_id)
      }
    },

    handleAddClose(user, phone) {
      this.selectProjects = []
      this.selectProjectIds = []
      this.checkedModels = []
      this.checkAll = []
      this.isIndeterminate = []
      this.form.user = user
      this.form.phone = phone
      for (const proj of this.projects) {
        this.checkedModels.push([])
        this.isIndeterminate.push(false)
        this.checkAll.push(false)
      }
    },
    handleAddOpen() {
      this.justOpen = false
    },
    handleEdit(index, row) {
      this.user = row
      for (const index in this.users) {
        var user = this.users[index]
        if (user.id == this.user.id) {
          this.user_index = index
          break
        }
      }
      var ids = this.user.project_id.split(',')
      this.editProjectsFormVisible = true
      this.$nextTick(() => {
        this.projects.forEach(project => {
          if (ids.indexOf(project.project_id) > -1) {
            this.$refs.editProjectsTable.toggleRowSelection(project, true);
          } else {
            this.$refs.editProjectsTable.toggleRowSelection(project, false);
          }
        })
      })
    },
    handleEditOpen() {
      this.handleAddClose(this.user.user_name, this.user.user_phone)
      var user_models = this.user.models
      this.justOpen = true

      for (const k in user_models) {
        var userModel = user_models[k]
        var user_project_id = userModel.project_id
        var userModels = userModel.models.split('|')
        for (const i in this.projects) {
          if (user_project_id == this.projects[i].project_id) {
            this.selectProjects.push(this.projects[i])
            this.selectProjectIds.push(user_project_id)
            if (userModels.length != this.models.length) {
              this.isIndeterminate[i] = true
              this.$set(this.checkAll, i, false)
            } else {
              this.isIndeterminate[i] = false
              this.$set(this.checkAll, i, true)
            }
            for (const userModel1 of userModels) {
              for (const j in this.models) {
                if (userModel1 == this.models[j].model_name) {
                  this.checkedModels[i].push(this.models[j])
                }
              }
            }
          }
        }
      }
    },
    alert(message, index) {
      this.$alert(message, '', {
        confirmButtonText: 'Confirm'
      }).then(() => {
        switch (index) {
          case 1:
            this.editProjectsFormVisible = false
            this.confirmLoading = false
            break
          default:
            break
        }
      }).catch(() => {
        switch (index) {
          case 1:
            this.editProjectsFormVisible = false
            this.confirmLoading = false
            break
          default:
            break
        }
      });
      ;
    },
    handleConfirmProjects(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmProjects();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    confirmProjects() {
      var ids = ''
      this.selectProjects.forEach(project => {
        ids = ids + project.project_id + ','
      })
      ids = ids.substring(0, ids.length - 1)

      var addModels = []
      for (const i in this.projects) {
        var checked = this.checkedModels[i]
        if (checked.length > 0) {
          var model_ids = ''
          checked.forEach(model => {
            model_ids = model_ids + model.model_name + '|'
          })
          model_ids = model_ids.substring(0, model_ids.length - 1)
          addModels.push({
            project_id: this.projects[i].project_id,
            models: model_ids
          })
        }
      }

      this.confirmLoading = true
      var name = this.form.user
      var phone = this.form.phone
      let postData = {
        cms_conid: window.localStorage.getItem('cons_id'),
        user: window.localStorage.getItem("token_key"),
        token: window.localStorage.getItem('token'),
        id: this.user.id,
        project_id: ids,
        phone: phone,
        user_name: name,
        model_list: addModels
      }
      axios.post(this.$store.getters.getBesServer + "CMSUpdateUser", postData).then(resp => {
        var errNo = resp.data.errno
        var errStr = resp.data.errstr
        if (errNo == "0") {
          this.alert('Edit projects successfully!', 1)
          this.users[this.user_index].project_id = ids
          this.users[this.user_index].models = addModels
          this.users[this.user_index].user_name = name
          this.users[this.user_index].user_phone = phone
          this.editProjectsFormVisible = false
          this.confirmLoading = false
        } else {
          this.editProjectsFormVisible = false
          this.confirmLoading = false
          alert('Edit projects Error: ' + errStr)
        }
      }).catch(error => {
        this.editProjectsFormVisible = false
        this.confirmLoading = false
        alert('Edit projects Error: ' + error)
      })
    },
    analProjects(project_id) {
      var names = []
      var ids = project_id.split(',')
      this.projects.forEach(project => {
        if (ids.indexOf(project.project_id) > -1) {
          names.push(project.project_name)
        }
      })
      return names
    },
    indexMethod(index) {
      return index + 1;
    },
  },
  mounted() {
    var that = this
    this.mountedLoading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    let postData = {
      cms_conid: window.localStorage.getItem('cons_id'),
      user: window.localStorage.getItem("token_key"),
      token: window.localStorage.getItem('token')
    }
    axios.post(this.$store.getters.getBesServer + "CMSProjList", postData).then(resp => {
      this.mountedLoading.close();
      var errNo = resp.data.errno
      var errStr = resp.data.errstr
      if (errNo == "0") {
        // that.projects = resp.data.result.projects
        // that.users = resp.data.result.users
        // that.roles = resp.data.result.roles
        // that.models = resp.data.result.models

        var projects = resp.data.result.projects
        var users = resp.data.result.users
        var roles = resp.data.result.roles
        var models = resp.data.result.models

        if (projects instanceof Array) {
          that.projects = projects
        } else {
          that.projects = []
        }
        if (users instanceof Array) {
          that.users = users
        } else {
          that.users = []
        }
        if (roles instanceof Array) {
          that.roles = roles
        } else {
          that.roles = []
        }
        if (models instanceof Array) {
          that.models = models
        } else {
          that.models = []
        }

        for (const proj of this.projects) {
          this.checkedModels.push([])
          this.isIndeterminate.push(false)
          this.checkAll.push(false)
        }
      } else {
        alert('Get Projects Error: ' + errStr)
      }
    }).catch(error => {
      this.mountedLoading.close();
      alert('Get Projects Error: ' + error)
    })
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
html, body, #container {
  height 100%
  width 100%
  background #24293c
  margin 0 auto
}

#mu_container {
  position relative
  margin: auto;
  width 1440px
  height 800px
  font-size 80px
}

.el-tag.el-tag--info {
  margin 3px 3px
}

>>> .el-input--small, .el-input--medium {
  width 80%
}
</style>



// WEBPACK FOOTER //
// src/components/manageuser/manageuser.vue